import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns/format";
import { differenceInDays } from "date-fns/differenceInDays";
import { useTranslation } from "react-i18next";
import { classNames } from "../utils/classnames";
import { COURSE_ARCHIVE_OVERLAP_PERIOD } from "../utils/constants";
import { Course } from "../courses/courses.types";
import "../i18n";

type CourseCardProps = {
    key:number;
    course: {
        course:Course;
    };
};

const THUMBNAIL_PLACEHOLDER = "/thumbnail-placeholder.png";

export const CourseCard: React.FC<CourseCardProps> = ({course}) => {
  const navigate = useNavigate();
  const [thumbnailLoaded, setThumbnailLoaded] = useState(false);
  const handleCourseCardClick = () => {
    navigate(`/course-details/${course.course.id}`);
  };
  const { t } = useTranslation();
  let message = "";
  const showWarningBanner =
          !!course.course.toBeArchivedOn &&
          differenceInDays(course.course.toBeArchivedOn, new Date()) <= COURSE_ARCHIVE_OVERLAP_PERIOD;
  if (showWarningBanner) {
    message=t("courseDetail.courseWillBeArchivedSoonCourseDetailsMessageThumbnailView", { toBeArchivedOn: format(course.course.toBeArchivedOn!, "dd.MM.yyyy")});
  }
  return <div className="cursor-pointer w-full rounded-lg shadow-lg overflow-hidden bg-white" onClick={handleCourseCardClick}>
    <img
      alt="kurs-thumbnail"
      className={classNames(
        "h-60 md:h-auto w-full object-cover object-center",
        thumbnailLoaded ? "hidden" : "block"
      )}
      src={THUMBNAIL_PLACEHOLDER}
    />
    <img
      alt=""
      className={classNames(
        "h-40 md:h-auto w-full object-cover object-center",
        thumbnailLoaded ? "block" : "hidden"
      )}
      src={course.course.thumbnailUrl}
      onLoad={() => setThumbnailLoaded(true)}
    />
    <h1 className="text-base md:text-lg break-words mx-4 my-4">
      {course.course.title}
    </h1>
    {
      showWarningBanner && <div className="bg-yellow-400 border-l-4 border-yellow-500 px-4 py-3 my-3 text-sm text-black shadow-md" role="alert">
        <p className="font-bold text-gray-500">{message}</p>
      </div>
    }
  </div>;
};

